import { render, staticRenderFns } from "./SubscriberItems.vue?vue&type=template&id=3abc62bf&scoped=true"
import script from "./SubscriberItems.vue?vue&type=script&lang=ts"
export * from "./SubscriberItems.vue?vue&type=script&lang=ts"
import style0 from "./SubscriberItems.vue?vue&type=style&index=0&id=3abc62bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc62bf",
  null
  
)

export default component.exports